var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.answer)?_c('FileUpload',{attrs:{"ownerType":"DynamicForm::Answer","ownerId":_vm.answer.id,"disabled":_vm.readOnly}}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }